import { Context, ContextMenu } from '../../models';

export class ContextService {
  context: Context[];
  contextMenu: ContextMenu[];

  constructor() {}

  getContext() {
    this.context = [
      {
        school: 'La Salle Arguello',
        course: [
          {
            name: '4A'
          },
          {
            name: '4B'
          },
          {
            name: '4B'
          }
        ]
      },
      {
        school: 'Escuela N18 - Gabriela Mistral',
        course: [
          {
            name: '4A'
          },
          {
            name: '4B'
          },
          {
            name: '4B'
          }
        ]
      }
    ];
    return this.context;
  }

  getContextMenu() {
    // Hardcodeo BORRAR!!
    this.contextMenu = [
      {
        text: 'Ir a Planificacion',
        parameter: 'planification'
      },
      {
        text: 'Listado de alumnos',
        parameter: 'students'
      },
      {
        text: 'Estadisticas',
        parameter: 'stats'
      }
    ];
    //
    return this.contextMenu;
  }
}
